export default __webpack_public_path__ + "static/media/editPencil.37ef26bc.svg";